import { CovidVaccineAdPage } from 'src/app/pages/covid-vaccine-ad/covid-vaccine-ad.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: CovidVaccineAdPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CovidVaccineAdPageRoutingModule {}
